import React from "react";
import EnvelopeSvg from "../Icons/envelopeSvg";
export default function Envelope() {
    return (
        <div className={"bg-[#7EC247] p-[15%] rounded-full w-full aspect-square"}>
            <EnvelopeSvg />
        </div>
    );
}